import React from 'react'

type DocumentIconProps = {
  active: boolean
}

const DocumentIcon: React.FC<DocumentIconProps> = ({ active }) => {
  return (
    <svg width="25" height="25" viewBox="0 0 21 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.013 7.04526C14.5145 7.04526 14.1104 6.64115 14.1104 6.14264V0.727051H3.27921C1.78373 0.727051 0.571411 1.93937 0.571411 3.43485V23.292C0.571411 24.7875 1.78373 25.9998 3.27921 25.9998H17.7208C19.2163 25.9998 20.4286 24.7875 20.4286 23.292V7.04526H15.013Z"
        fill={active ? '#2D60FF' : '#5B73A0'}
      />
    </svg>
  )
}
export default DocumentIcon
